import { useState, useEffect } from 'react'
import { SectionCaseStudiesGridItem } from '@/components/organisms/SectionCaseStudiesGrid/types'

export function useFetchCaseStudies() {
  const [data, setData] = useState<SectionCaseStudiesGridItem[]>([])
  const [loading, setLoading] = useState<boolean>(false)
  const [error, setError] = useState<Error | null>(null)

  useEffect(() => {
    const useProdSpace =
      window?.location.hostname === 'beebole.com' || window?.location.hostname === 'staging.beebole.com'
    const token = useProdSpace ? process.env.GATSBY_STORYBLOK_TOKEN_PROD : process.env.GATSBY_STORYBLOK_TOKEN_DEV
    const isEditor = window?.location.pathname.includes('editor')
    const version = isEditor ? 'draft' : 'published'

    async function fetchCaseStudies() {
      setLoading(true)
      setError(null)

      try {
        const response = await fetch(
          `https://api.storyblok.com/v2/cdn/stories?content_type=template_case_study&is_startpage=false&version=${version}&token=${token}`
        )

        if (!response.ok) {
          throw new Error(`Error: ${response.status} - ${response.statusText}`)
        }

        const result = await response.json()
        setData(result?.stories)
      } catch (err) {
        setError(err as Error)
      } finally {
        setLoading(false)
      }
    }

    fetchCaseStudies()
  }, [])

  return { data, loading, error }
}
